function initClarity(): void {
  if (document.getElementById('clarity-script')) return

  const clarity = document.createElement('script')
  clarity.type = 'text/javascript'
  clarity.innerHTML = `(function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", "ra5xvllgct");`
  const timeout = setTimeout(() => {
    document.head.appendChild(clarity)
    clearTimeout(timeout)
  }, 1 * 1000)
}
export default initClarity
